module.exports = __webpack_public_path__ + "static/media/10_A.c73dff3a.jpg";